const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMWM2LjA3NSAwIDExIDQuOTI1IDExIDExcy00LjkyNSAxMS0xMSAxMVMxIDE4LjA3NSAxIDEyaDJhOSA5IDAgMSAwIDktOWMtMi44NCAwLTQuOTU1Ljc5MS02Ljg4NiAzSDh2MkgyVjEuOTkxaDJ2Mi4yNjVDNi4yMzcgMS45MTEgOC43ODcgMSAxMiAxem0xIDV2NWg0djJoLTZWNmgyeiIgIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export {
  M as default
};
//# sourceMappingURL=clock_restore-bf17eebb.mjs.map
